import { useState, useEffect } from 'react'
import './App.css';
import Nav from './components/Nav'
import Title from './components/Title'
import Streamrs from './components/Streamers';
import api from './api'
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'




function Root() {

  const [data, setData] = useState([])
  const location = useLocation()
  const [pages, setPages] = useState(8)

  // 所有實況主的ID

  useEffect(() => {
    const fetchData = async () => {
      let request = await api.get(`https://api.twitch.tv/helix/streams?first=${pages}`)
      setData(request.data.data)
    }
    fetchData()
  }, [pages])

  const scrollToEnd = () => {
    setPages(prev => prev + 4)
  }


  useEffect(() => {

    const reachedBottom = () => {
      if (window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight) {
        scrollToEnd()
      }
    }

    window.addEventListener('scroll', reachedBottom)

    return () => {
      window.removeEventListener('scroll', reachedBottom)
    }
  }, [])




  return (
    <div >
      <Title />
      <Nav />
      <TransitionGroup component={null}>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <Routes location={location} >
            <Route path='/' element={<Streamrs data={data} />} />
            <Route path='/Apex' element={<Streamrs data={data} type='Apex Legends' />} />
            <Route path='/LOL' element={<Streamrs data={data} type="Just Chatting" />} />
            <Route path='/Chat' element={<Streamrs data={data} type="League of Legends" />} />
          </Routes>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
}

const App = () => <BrowserRouter><Root /></BrowserRouter>;

export default App;
